<template>
  <section class="flex flex-col items-center justify-center py-6">
    <div>
      <img
        src="@/assets/images/logo-mod.png"
        alt="IWC Logo"
        class="h-32 w-32 object-contain"
      />
    </div>
    <div class="py-5 text-3xl font-semibold text-white text-center space-y-1">
      <h1>Birthdate Update Form</h1>
    </div>

    <div
      class="w-full sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-4"
    >
      <form
        @submit.prevent="updatingBirthdate()"
        class="py-86 flex flex-col gap-3"
      >
        <h2 class="text-xl text-white font-medium px-2 text-center">
          {{ getMemberName }}
        </h2>

        <h2 class="text-sm text-white font-medium">Birthdate</h2>
        <input
          required
          v-model="birthdate"
          type="date"
          class="h-14 w-full mx-auto px-4 py-3 rounded-xl bg-white/20 backdrop-blur-md border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-white/40 focus:bg-white/25 transition appearance-none"
        />
        <h2 class="text-sm text-white font-medium">Confirm Birthdate</h2>
        <input
          required
          v-model="confirmbirthdate"
          type="date"
          class="h-14 w-full mx-auto px-4 py-3 rounded-xl bg-white/20 backdrop-blur-md border border-white/30 text-white focus:outline-none focus:ring-2 focus:ring-white/40 focus:bg-white/25 transition appearance-none"
        />

        <button
          class="my-2 py-3 w-full rounded-md bg-orange-600 text-white text-base font-semibold shadow-lg hover:opacity-90 active:scale-95 transition duration-200"
        >
          <span v-if="!isLoading">Submit</span>

          <span v-else class="flex items-center justify-center gap-2">
            <LoadingSVG />
            initializing...
          </span>
        </button>

        <span
          v-if="isError"
          class="inline-block px-8 py-4 text-center text-sm font-semibold text-red-500 bg-white/20 rounded-md"
        >
          {{ errorMessage }}. <br />
          <span
            v-if="
              errorMessage !== 'Birthdate and confirm birthdate do not match'
            "
          >
            Click
            <router-link
              :to="`/auth?pid=${publicId}`"
              class="text-blue-700 font-medium"
              >here</router-link
            >
            to return to login.
          </span>
        </span>
      </form>
    </div>
  </section>
</template>
<script>
import { inject, onMounted, ref, reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "AuthView",

  setup() {
    const route = useRoute();
    const router = useRouter();
    const publicId = ref();
    const axios = inject("$axios");
    const Swal = inject("$swal");
    const isError = ref(false);
    const isLoading = ref(false);
    const errorMessage = ref();
    const formData = reactive({
      public_id: null,
      birthdate: null,
      confirmbirthdate: null,
    });

    publicId.value = route.params.id;
    onMounted(() => {
      renderUserCard();
    });
    const getMemberName = ref();

    const renderUserCard = async () => {
      try {
        const { data } = await axios.get(
          `/meta/api/amap/user/${publicId.value}`
        );
        getMemberName.value = data.data.membername;
      } catch (error) {
        console.log("render", error);
      }
    };
    const updatingBirthdate = async () => {
      try {
        isLoading.value = true;

        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        formData.public_id = publicId.value;

        await axios.put(`/meta/api/amap/member/birthdate`, formData);
        await delay(2000);
        isLoading.value = false;
        isError.value = false;

        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Birthdate updated successfully.",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            router.push(`/auth?pid=${publicId.value}`); // <-- change this to your desired route
          }
        });
      } catch (error) {
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await delay(2000);
        isLoading.value = false;
        isError.value = true;
        errorMessage.value =
          error.response?.data?.message || "Something went wrong.";
      }
    };

    return {
      publicId,
      renderUserCard,
      getMemberName,
      ...toRefs(formData),
      updatingBirthdate,
      isError,
      errorMessage,
      isLoading,
    };
  },
};
</script>
